import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["children"],
  _excluded2 = ["children"],
  _excluded3 = ["children"],
  _excluded4 = ["children"];
import React from 'react';
export { default as HeadProvider } from './headProvider';
import { Helmet } from 'react-helmet-async';
Helmet.defaultProps.defer = false;
export var Link = props => {
  var {
      children
    } = props,
    tagProps = _objectWithoutProperties(props, _excluded);
  return /*#__PURE__*/React.createElement(Helmet, null, /*#__PURE__*/React.createElement("link", tagProps, children));
};
export var Meta = props => {
  var {
      children
    } = props,
    tagProps = _objectWithoutProperties(props, _excluded2);
  return /*#__PURE__*/React.createElement(Helmet, null, /*#__PURE__*/React.createElement("meta", tagProps, children));
};
export var Style = props => {
  var {
      children
    } = props,
    tagProps = _objectWithoutProperties(props, _excluded3);
  return /*#__PURE__*/React.createElement(Helmet, null, /*#__PURE__*/React.createElement("style", tagProps, children));
};
export var Title = props => {
  var {
      children
    } = props,
    tagProps = _objectWithoutProperties(props, _excluded4);
  return /*#__PURE__*/React.createElement(Helmet, null, /*#__PURE__*/React.createElement("title", tagProps, children));
};